import { useWhitelabelConfig } from '@mm/hooks/src/use-whitelabel-config';
import { TriangleWarningIcon } from '@mm/icons';
import classNames from 'classnames';
import React from 'react';
import { useChannelConnection } from '../InputTriggers/use-channel-connection';
import css from './NeedsEmailAlert.module.css';

type Props = {
  className?: string;
};

export const NeedsEmailAlert = ({ className }: Props) => {
  const { isEmailConnected } = useChannelConnection(() => {});
  const { pixelName: whitelabelPixelName } = useWhitelabelConfig();
  const pixelName = whitelabelPixelName
    ? `${whitelabelPixelName} Lead Generator`
    : 'X-Ray Lead Generation Pixel';

  if (isEmailConnected) {
    return <></>;
  }

  return (
    <div className={classNames(className, css.container)}>
      <TriangleWarningIcon />
      <span className={css.text}>
        {pixelName} requires an email to be connected
      </span>
    </div>
  );
};
